<template>
  <div>
    <vxe-grid
      ref="table"
      row-id="changeLogId"
      size="small"
      round
      resizable
      auto-resize
      highlight-hover-row
      :height="tableHeight"
      :loading="loading"
      :data="tableData"
      :columns="tableColumn"
      :toolbar-config="tableToolbar"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImgUrl="{ row }">
        <el-image
          :src="
            row.imageCode
              ? $osscdn(row.imageCode)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:stock="{ row }">
        <span>
          {{ row.changeNum ? row.changeNum : '0' }}
          {{ row.fabricUnit ? row.fabricUnit : '' }}
        </span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  components: {},
  props: {
    tableData: {
      type: Array,
      value: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: this.reload,
        },
        zoom: true,
      },
      tableColumn: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          type: 'seq',
        },
        // {
        //   field: 'imageCode',
        //   width: 120,
        //   title: '图片',
        //   align: 'center',
        //   slots: { default: 'defaultImgUrl' },
        // },
        {
          headerAlign: 'center',
          align: 'left',
          field: 'fabricNo',
          minWidth: 180,
          title: this.$l('table_label_fabric_no') || '面料编号',
        },
        {
          headerAlign: 'center',
          align: 'left',
          field: 'fabricName',
          minWidth: 300,
          title: this.$l('table_label_fabric_name') || '面料名称',
        },
        {
          headerAlign: 'center',
          align: 'left',
          field: 'fabricColorNo',
          minWidth: 200,
          title: this.$l('table_label_fabric_color_no') || '颜色编号',
        },
        {
          headerAlign: 'center',
          align: 'left',
          field: 'fabricColorTitle',
          minWidth: 350,
          title: this.$l('table_label_fabric_color_title') || '颜色名称',
        },
        {
          field: 'changeNum',
          minWidth: 100,
          title: this.$l('form_label_change_num') || '变动数量',
          slots: { default: 'stock' },
          headerAlign: 'center',
          align: 'center',
        },
        {
          headerAlign: 'center',
          align: 'center',
          field: 'logTime',
          width: 170,
          title: this.$l('table_label_logTime') || '变动时间',
        },
        {
          headerAlign: 'center',
          align: 'center',
          field: 'modifyBillNo',
          width: 170,
          title: this.$l('form_label_bill_no') || '业务单据编号',
        },
        {
          headerAlign: 'center',
          align: 'left',
          field: 'modifyDescription',
          minWidth: 300,
          title: this.$l('form_label_desc') || '变动说明',
        },
      ],
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
    }
  },
  methods: {
    reload() {
      this.$emit('submit')
    },
  },
}
</script>
<style lang="scss" scoped></style>
